import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import $ from 'jquery'

import API from '../../api/api'
import { getTrainingType } from '../../helpers/helpers'
import { getAssetLink } from '../../helpers/get-asset-link'
import Avatar from '../../Avatar'

import { StripePaymentButton } from './stripe-payment-modal'
import TrainingDetailsLearnMore from './TrainingDetailsLearnMore'
import Icon from './../Icons'

class TrainingDetails extends React.Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onClose = this.onClose.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
    this.toggleLearnMorePopup = this.toggleLearnMorePopup.bind(this)
    this.state = {
      pending: false,
      learnMoreOpened: false,
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.clickHandler)
    window.addEventListener('keydown', this.handleEscape)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickHandler)
    window.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27) {
      this.onClose()
    }
  }

  clickHandler(e) {
    const className = $(e.target).attr('class')
    if (className && className.trim() === 'ctp-training-details') {
      this.onClose()
    }
  }

  onClose(_e) {
    this.props.onUpdate('', null)
  }

  toggleLearnMorePopup() {
    this.setState((state) => ({ learnMoreOpened: !state.learnMoreOpened }))
  }

  handleSubmit(e, training) {
    const { type, onUpdate } = this.props
    switch (type) {
      case 'free':
        if (training.buildingId && training.signUpLink) {
          window.open(training.signUpLink)
        } else {
          this.setState({ pending: true })
          API.signToTraining(training.id)
            .then(() => onUpdate('', null, true))
            .catch((error) => {
              throw new Error(error)
            })
        }
        break
      case 'cancel':
        if (getTrainingType(training) === 'class') {
          this.setState({ pending: true })
          API.signToTraining(training.id)
            .then(() => onUpdate('cancel-confirmation', training, true))
            .catch((error) => {
              throw new Error(error)
            })
        } else {
          onUpdate('cancel-popup', training)
        }
        break
      case 'paid':
        // TODO: dead code - payment now handled via checkout.session.completed webhook
        break
      default:
        return {}
    }
  }

  renderActionButton() {
    const { training, type } = this.props
    const classNameTypeModifier = type === 'cancel' ? ' cancel' : '-green'
    const buttonText =
      type === 'cancel'
        ? 'Cancel appointment'
        : type === 'paid'
          ? `Join Lesson for $${training.cost}`
          : 'Join Free Class'

    const className =
      type === 'paid'
        ? 'button button-primary ctp-payment-button'
        : `ctp-training-details-submit button button${classNameTypeModifier}`
    const eventDate = moment(training.date)
    if (moment().isBefore(eventDate, 'hour')) {
      // TODO how much time before training should client be able to enroll?
      if (type !== 'paid') {
        return (
          <Link to="/dashboard/app-download" className={className}>
            {buttonText}
          </Link>
        )
      } else {
        return (
          <StripePaymentButton
            context={{ trainingId: training.id }}
            description={training.name}
            email={this.props.userData.user.email}
            amount={training.cost}
            onPaymentSuccess={() => this.props.onUpdate('', null, true)}
          />
        )
      }
    } else {
      return <p style={{ position: 'absolute', bottom: '25px' }}> Past Event </p>
    }
  }
  render() {
    const { training, className } = this.props
    const trainingType = getTrainingType(training)
    const eventDate = moment(training.date).tz(training.buildingInfo.timezone)
    const date = eventDate.format('DD MMMM, dddd')
    const start = eventDate.format('LT')
    const end = eventDate.add(training.duration, 'minutes').format('LT')
    return (
      <div className={`ctp-training-details ${className || ''}`}>
        <div className="ctp-training-details-image">
          <img
            src={getAssetLink({
              path: 'chitown-images/training',
              file: training.image,
              fallback: { file: 'training_image.png' },
            })}
            alt={training.name}
          />
        </div>
        <div className="ctp-training-details-window">
          <div className="ctp-training-details-window__header">
            <Avatar size="big" background="#2a2d2e">
              <Icon icon={training.type.icon} fill="#ffffff" />
            </Avatar>
            <h1> {training.name} </h1>
            <div className="ctp-training-details-window__close" onClick={this.onClose}>
              <Icon icon="cross" />
            </div>
          </div>
          <div className="ctp-training-details-window__body">
            <div className="ctp-section ctp-section-date">
              <div className="ctp-title">{`${start} - ${end}`}</div>
              <div className="ctp-detail">{date}</div>
            </div>
            <div className="ctp-section ctp-section-trainer">
              <Avatar
                size="big"
                square
                zoomTitle={`${training.trainerId.firstName} ${training.trainerId.lastName}`}
                zoomable
              >
                <img
                  src={getAssetLink({
                    path: 'chitown-avatar/avatar',
                    file: training.trainerId.avatar,
                  })}
                />
              </Avatar>
              <div className="ctp-section">
                <div className="ctp-title">{`${training.trainerId.firstName} ${training.trainerId.lastName}`}</div>
                <div className="ctp-detail">Staff</div>
              </div>
            </div>
            {trainingType !== 'appointment' && (
              <div className="ctp-section ctp-section-trainer ctp-section-description">
                <div className="ctp-section">
                  <div className="ctp-title">Description</div>
                  <div className="ctp-detail">{training.description}</div>
                  {training.file && training.file.length > 4 && (
                    <button
                      className="button is-small is-outlined is-active"
                      onClick={this.toggleLearnMorePopup}
                    >
                      Learn more
                    </button>
                  )}
                </div>
              </div>
            )}
            {training.buildingId !== null && (
              <div className="ctp-row">
                <p className="ctp-title">Location</p>{' '}
                <span className="ctp-detail">{training.buildingInfo.name}</span>
              </div>
            )}
            <div className="ctp-row">
              <p className="ctp-title">Event Type</p>{' '}
              <span className="ctp-detail">{training.type.name}</span>
            </div>
            {!['appointment', 'reminder'].includes(trainingType) && !training.signUpLink && (
              <React.Fragment>
                <div className="ctp-row">
                  <p className="ctp-title">Registered</p>{' '}
                  <span className="ctp-detail">{training.taken}</span>
                </div>
                <div className="ctp-row">
                  <p className="ctp-title">Capacity</p>{' '}
                  <span className="ctp-detail">{training.capacity}</span>
                </div>
              </React.Fragment>
            )}
            {this.renderActionButton()}
          </div>
        </div>
        <TrainingDetailsLearnMore
          file={training.file || ''}
          opened={this.state.learnMoreOpened}
          close={this.toggleLearnMorePopup}
        />
      </div>
    )
  }
}

TrainingDetails.propTypes = {
  training: PropTypes.object,
  type: PropTypes.string,
  userData: PropTypes.object,
  onUpdate: PropTypes.func,
  className: PropTypes.string,
}

export default TrainingDetails
